module.exports = __webpack_public_path__ + "img/chat.0d4819e3.svg";